var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _path3, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucherFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 96,
    width: 472,
    height: 320,
    rx: 20,
    fill: "#4398D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M449.5 96c-105 224-242.667 317.167-324 320h352c12 0 14.667-10 14.5-15V113c-1-7-4.844-12.937-12.5-16-5-2-17.5-1-30-1z",
    fill: "#3E8CC7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 334,
    width: 100,
    height: 12,
    rx: 6,
    fill: "#87CED9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 334,
    width: 100,
    height: 12,
    rx: 6,
    fill: "#87CED9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 226,
    width: 110,
    height: 12,
    rx: 6,
    fill: "#87CED9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 226,
    width: 110,
    height: 12,
    rx: 6,
    fill: "#87CED9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 362,
    width: 230,
    height: 12,
    rx: 6,
    fill: "#87CED9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 254,
    width: 186,
    height: 12,
    rx: 6,
    fill: "#87CED9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.625 298.417a4.293 4.293 0 10-.001-8.585 4.293 4.293 0 00.001 8.585zM146.833 298.417a4.292 4.292 0 100-8.584 4.292 4.292 0 000 8.584zM65.292 208.292h17.166l11.502 57.465a8.582 8.582 0 008.583 6.91h41.715a8.588 8.588 0 008.584-6.91l6.866-36.007H86.75",
    stroke: "#3A4856",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A4856",
    d: "M20 137h472v43H20z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 334,
    width: 59,
    height: 40,
    rx: 5,
    fill: "#B48951"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherFlat);
export default __webpack_public_path__ + "static/media/voucher-flat.e81421ea3e436c2addfcff86a3f9ff1d.svg";
export { ForwardRef as ReactComponent };